module.exports = __webpack_public_path__ + "img/eri.e5e5e397.svg";